import { RoleFieldsFragment, RoleScope } from '@/generated/graphql';

export interface ScopedPermission {
  scope: RoleScope;
  resourceId?: string | null;
  permission: readonly string[];
}

export function hasPermission(
  roles: readonly RoleFieldsFragment[],
  permission: ScopedPermission | readonly string[],
): boolean {
  const perm: ScopedPermission = Array.isArray(permission)
    ? { scope: RoleScope.Root, permission }
    : (permission as ScopedPermission);

  return Boolean(
    roles.find(
      (role) =>
        role.scope === perm.scope &&
        (!perm.resourceId || role.resourceId === perm.resourceId) &&
        (!perm.permission.length ||
          perm.permission.some((p) => role.permissions.includes(p))),
    ),
  );
}
